var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282D32",
    fillRule: "evenodd",
    d: "M2.667 12h10.666c.367 0 .667-.3.667-.667 0-.366-.3-.666-.667-.666H2.667c-.367 0-.667.3-.667.666s.3.667.667.667m0-3.333h10.666c.367 0 .667-.3.667-.667s-.3-.667-.667-.667H2.667C2.3 7.333 2 7.633 2 8s.3.667.667.667m-.667-4c0 .366.3.666.667.666h10.666c.367 0 .667-.3.667-.666S13.7 4 13.333 4H2.667C2.3 4 2 4.3 2 4.667",
    clipRule: "evenodd"
  })));
};
export default SvgMenu;